module.exports = __webpack_public_path__ + "static/media/expand-icon-2.6aa0ef0c.svg";